import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';

import SelectJoinHeaderComponent from './selectJoinHeader.component';

const styles = () => ({
  icon: {
    textAlign: 'center',
    paddingTop: '35px',
  },
  block: {
    padding: '10px 20px',
  },
});

class SelectJoinHeaders extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange(this.props.index, { [event.target.name]: event.target.value });
  }

  render() {
    const { session, join, classes } = this.props;

    return (
      <Grid container className={classes.block}>
        <Grid sm={5} item >
          <SelectJoinHeaderComponent
            name="sourceHeader"
            session={session}
            fileId={join.sourceFile}
            onChange={this.handleChange}
            value={join.sourceHeader}
          />
        </Grid>
        <Grid sm={2} className={classes.icon} item >
          <Icon>arrow_back</Icon>
        </Grid>
        <Grid sm={5} item >
          <SelectJoinHeaderComponent
            name="targetHeader"
            session={session}
            fileId={join.targetFile}
            onChange={this.handleChange}
            value={join.targetHeader}
          />
        </Grid>
      </Grid>
    );
  }
};

SelectJoinHeaders.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  join: PropTypes.shape({
    sourceFile: PropTypes.string,
    targetFile: PropTypes.string,
    sourceField: PropTypes.string,
    targetField: PropTypes.string,
  }).isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    }),
  }).isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(SelectJoinHeaders);
